import {
  CARE_SOURCE_CONTEXTS,
  CARE_SOURCE_DOCUMENT_TYPES,
  CARE_SOURCE_KINDS,
} from './careSourceMetadata';

const cleanToken = (value = '') => String(value || '').trim().toLowerCase();

const normalizeToken = (value = '', allowedValues = [], fallback = '') => {
  const token = cleanToken(value);
  return allowedValues.includes(token) ? token : fallback;
};

export const normalizeCareSourceScope = ({
  sourceContext = '',
  documentType = '',
  sourceKind = '',
  sourceType = '',
} = {}) => ({
  sourceContext: normalizeToken(sourceContext, Object.values(CARE_SOURCE_CONTEXTS), ''),
  documentType: normalizeToken(documentType, Object.values(CARE_SOURCE_DOCUMENT_TYPES), ''),
  sourceKind: normalizeToken(sourceKind, Object.values(CARE_SOURCE_KINDS), ''),
  sourceType: cleanToken(sourceType),
});

export const careSourceMatchesScope = (source = {}, scope = {}) => {
  const normalizedScope = normalizeCareSourceScope(scope);

  if (normalizedScope.sourceContext && source.sourceContext !== normalizedScope.sourceContext) {
    return false;
  }

  if (normalizedScope.documentType && source.documentType !== normalizedScope.documentType) {
    return false;
  }

  if (normalizedScope.sourceKind && source.sourceKind !== normalizedScope.sourceKind) {
    return false;
  }

  if (normalizedScope.sourceType && source.sourceType !== normalizedScope.sourceType) {
    return false;
  }

  return true;
};

export const buildCareSourceHistoryPath = ({
  sourceContext = '',
  documentType = '',
  sourceKind = '',
  sourceType = '',
} = {}) => {
  const scope = normalizeCareSourceScope({ sourceContext, documentType, sourceKind, sourceType });
  const params = new URLSearchParams();

  Object.entries(scope).forEach(([key, value]) => {
    if (value) params.set(key, value);
  });

  const query = params.toString();
  return query ? `/sources?${query}` : '/sources';
};

export const getCareSourceScopeTitle = ({
  sourceContext = '',
  documentType = '',
  sourceKind = '',
} = {}) => {
  const scope = normalizeCareSourceScope({ sourceContext, documentType, sourceKind });

  if (scope.documentType === CARE_SOURCE_DOCUMENT_TYPES.DOCTOR_NOTE) return 'Medical source history';
  if (scope.documentType === CARE_SOURCE_DOCUMENT_TYPES.LEGAL_DOCUMENT) return 'Legal source history';
  if (scope.documentType === CARE_SOURCE_DOCUMENT_TYPES.SCHOOL_DOCUMENT) return 'School source history';
  if (scope.documentType === CARE_SOURCE_DOCUMENT_TYPES.SPREADSHEET) return 'Spreadsheet source history';
  if (scope.sourceKind === CARE_SOURCE_KINDS.IMAGE) return 'Image source history';
  if (scope.sourceContext === CARE_SOURCE_CONTEXTS.KNOWLEDGE) return 'Care Knowledge source history';
  if (scope.sourceContext === CARE_SOURCE_CONTEXTS.PROFILE) return 'Profile source history';
  if (scope.sourceContext === CARE_SOURCE_CONTEXTS.MEDICATION) return 'Medication source history';
  if (scope.sourceContext === CARE_SOURCE_CONTEXTS.GOAL) return 'Goal source history';
  if (scope.sourceContext === CARE_SOURCE_CONTEXTS.APPOINTMENT) return 'Appointment source history';
  if (scope.sourceContext === CARE_SOURCE_CONTEXTS.TIMELINE) return 'Timeline source history';

  return 'Source history';
};
